// extracted by mini-css-extract-plugin
export default {"faqBeginBtn":"FAQbeginBtn_faqBeginBtn__Q-4ng"};